import { useMutation } from '@tanstack/react-query';

import { type MyPosPaymentProvider } from 'src/features/parkingManagement/api/paymentPaymentProviders/useGetMyPOSPaymentProvider';
import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/parkings/:parkingId/mypos-payment-provider/';

export type CreateMyPOSPaymentProviderFnType = typeof createMyPOSPaymentProvider;

export type DTO = {
    parkingId: string;
    store_id: string;
    client_number: string;
    public_certificate: string | Blob;
    private_key: string | Blob;
    key_index?: number;
};

const createMyPOSPaymentProvider = ({ parkingId, ...data }: DTO): Promise<Omit<MyPosPaymentProvider, 'id'>> => {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
        if (value === undefined || value === null) return;

        if (value instanceof Blob) {
            formData.append(key, value);
        } else {
            formData.append(key, String(value));
        }
    });

    return axios.post(formatResourcePath(RESOURCE, { parkingId }), formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

interface UseCreateMyPOSPaymentProvider
    extends MutationConfig<CreateMyPOSPaymentProviderFnType, GeneralSmartParkError> {}

export const useCreateMyPosPaymentProvider = (options: UseCreateMyPOSPaymentProvider) =>
    useMutation({
        mutationFn: createMyPOSPaymentProvider,
        ...options,
    });
